import { EditorState } from "lexical";

import { Team } from "./Team";

export interface CommunicationTemplate {
    id: string;
    friendlyId: number;
    name: string;
    description?: string;
    channel: string;
    state: CommunicationTemplateState;
    emailSubject?: string;
    body: string;
    bodySource?: string;
    createdAt?: string;
    createdBy?: string;
    updatedAt?: string;
    updatedBy?: string;
    teams: Array<Team>;
}

export const CommunicationTemplateState = {
    UNSET: "",
    LIVE: "live",
    DRAFT: "draft",
} as const;
export type CommunicationTemplateState = (typeof CommunicationTemplateState)[keyof typeof CommunicationTemplateState];

export const CommunicationTemplateChannel = {
    sms: "sms",
    email: "email",
} as const;
export type CommunicationTemplateChannelType =
    (typeof CommunicationTemplateChannel)[keyof typeof CommunicationTemplateChannel];

export type CommunicationTemplateDTO = Omit<CommunicationTemplate, "teams" | "bodySource"> & {
    teamIds: Array<string>;
    bodySource?: EditorState | string;
};
